const OrganizoProvimin = () => {
  return <div><h2>Organize Exam Page Content</h2></div>;
};

export default OrganizoProvimin;
